'use client';

import { useEffect } from 'react';

interface FontConfig {
  type: 'Custom' | 'Google';
  id: string;
}

interface FontsLoaderProps {
  heading?: FontConfig;
  body?: FontConfig;
}

export const FontsLoader = ({
  heading = { type: 'Google', id: 'Marcellus' },
  body = { type: 'Google', id: 'Josefin Sans' },
}: FontsLoaderProps) => {
  useEffect(() => {
    const style = document.createElement('style');

    const fontFaceRules: string[] = [];

    // Handle Custom Fonts
    if (heading.type === 'Custom') {
      fontFaceRules.push(`
        @font-face {
          font-family: '${heading.id}';
          src: url('/fonts/${heading.id}.woff2') format('woff2');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `);
    }

    if (body.type === 'Custom') {
      fontFaceRules.push(`
        @font-face {
          font-family: '${body.id}';
          src: url('/fonts/${body.id}.woff2') format('woff2');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `);
    }

    // Append Google Fonts if any
    const googleFonts: string[] = [];
    if (heading.type === 'Google') googleFonts.push(heading.id);
    if (body.type === 'Google') googleFonts.push(body.id);

    if (googleFonts.length > 0) {
      const googleFontsLink = `https://fonts.googleapis.com/css2?${googleFonts
        .map(
          (font) =>
            `family=${font.split(' ').join('+')}:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900`,
        )
        .join('&')}&display=swap`;

      const googleLinkTag = document.createElement('link');
      googleLinkTag.rel = 'stylesheet';
      googleLinkTag.href = googleFontsLink;
      document.head.appendChild(googleLinkTag);
    }

    // Inject font-face rules into the document
    if (fontFaceRules.length > 0) {
      style.textContent = fontFaceRules.join('\n');
      document.head.appendChild(style);
    }
  }, [heading, body]);

  return null;
};
